import React from 'react';

/**
 * Estonian display formatting for the KHG report: decimal comma, space as the thousands separator.
 * The API sends unrounded values, so all rounding to the report's one decimal happens here.
 */

/** The emission unit, with the subscript the report uses throughout. */
export const TCO2E = <>tCO<sub>2</sub>e</>;

function format(value: number, fractionDigits: number) {
    return value.toLocaleString('et-EE', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    });
}

/** Emission figures (tCO2e), one decimal — e.g. "2 504,3". */
export function emission(value: number | null | undefined) {
    return format(value ?? 0, 1);
}

/** Percentages, one decimal — e.g. "35,5". */
export function percent(value: number | null | undefined) {
    return format(value ?? 0, 1);
}

/** Consumed quantities, no decimals — e.g. "427 000". */
export function quantity(value: number | null | undefined) {
    return format(value ?? 0, 0);
}

/** Bar segment widths must stay within 0-100 so a floored/rounded figure cannot overflow the row. */
export function barWidth(value: number | null | undefined) {
    return Math.max(0, Math.min(100, value ?? 0)) + '%';
}
